import React, { Fragment } from 'react';
import useMediaQuery from '@material-ui/core/useMediaQuery';

/**
 * SizeClassProvider
 *
 * adds the bp-size-[breakpoint] css class to its child components
 *
 * @param {[type]} props [description]
 */
export const SizeClassProvider = (props) => {

    let isSm = useMediaQuery(theme => theme.breakpoints.between("xs","sm"));
    let isMd = useMediaQuery(theme => theme.breakpoints.between("sm","md"));
    let isLg = useMediaQuery(theme => theme.breakpoints.between("md","lg"));
    let isXl = useMediaQuery(theme => theme.breakpoints.up("lg"));
    let breakpoint = null;

    if( isXl ) {
        breakpoint = "xl";
    } else if( isLg ) {
        breakpoint = "lg";
    } else if( isMd ) {
        breakpoint = "md";
    } else if( isSm ) {
        breakpoint = "sm";
    } else {
        breakpoint = "xs";
    }
    let cssSize = " bp-size-" + breakpoint;

    // apply the bp-size css class
    const children = React.Children.map(props.children,
        (child) => {
            let cn = "";
            if( child.props.className ) {
                cn = child.props.className;
            }
            cn += cssSize;
            return React.cloneElement(child, { className: cn , renderBreakpoint: breakpoint });
        });

    // render
    return <Fragment>
            {children}
        </Fragment>
    ;
}


/**
 * ---------------------------------------------------------------------
 * withMediaQuery
 * ---------------------------------------------------------------------
 * simple HOC for useMediaQuery from Material UI
 * so we can use it inside our class components
 *
 * Material UI has not its own HOC for this :(
 *
 * @see https://material-ui.com/components/use-media-query/
 *
 * @param  {[type]} args [description]
 * @return {[type]}      [description]
 */

export const withMediaQuery = (...args) => Component => props => {
    const mediaQuery = useMediaQuery(...args);
    return <Component mediaQuery={mediaQuery} {...props} />;
}
